import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7b9aefce")

_pushScopeId("data-v-7b9aefce")
const _hoisted_1 = { class: "doctor-item" }
const _hoisted_2 = { class: "image-container" }
const _hoisted_3 = {
  key: 0,
  class: "doctor-item-detail"
}
const _hoisted_4 = { class: "doctor-item-detail__desc" }
const _hoisted_5 = { class: "p-mb-2 doctor-name -bold" }
const _hoisted_6 = { class: "doctor-description" }
const _hoisted_7 = {
  key: 0,
  class: "-medium"
}
const _hoisted_8 = {
  key: 0,
  class: "favorites"
}
const _hoisted_9 = {
  key: 1,
  class: "button"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _ctx.state.image,
        alt: _ctx.state.doctorName
      }, null, 8, ["src", "alt"])
    ]),
    (_ctx.state.isDetail)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h5", _hoisted_5, _toDisplayString(_ctx.state.doctorName), 1),
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.profiles.split('\n'), (p, i) => {
                return (_openBlock(), _createBlock(_Fragment, { key: i }, [
                  (i < 2)
                    ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(p), 1))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _renderSlot(_ctx.$slots, "desc", {}, undefined, true)
          ]),
          (_ctx.$slots.favorites)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _renderSlot(_ctx.$slots, "favorites", {}, undefined, true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.button)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "button", {}, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.$slots.detail)
        ? _renderSlot(_ctx.$slots, "detail", { key: 1 }, undefined, true)
        : _createCommentVNode("", true),
    (_ctx.$slots.footer)
      ? _renderSlot(_ctx.$slots, "footer", { key: 2 }, undefined, true)
      : _createCommentVNode("", true)
  ]))
})